import React, { useContext, useState } from 'react';
import PropTypes from 'prop-types';
import { useQuery } from 'react-apollo';
import { BasePage, Helmet, ErrorCard, FourOhFourError, StaticContext } from '@sm/webassets';
import publishedApplicationListingDetails from '../Details/published-application-listing-details.graphql';
import AppDirectoryAppDetailsSkeleton from '../Details/AppDirectoryAppDetailsSkeleton';
import AppDetails from './AppDetails';
import getCanonicalUrlOrNoIndex from '~app/helpers/getCanonicalUrlOrNoIndex';
import ModernHeader from '../../components/ModernHeader';

export const DetailsPage = ({
  match: {
    params: { appId },
  },
}) => {
  const {
    environment: { subdomain, domain, tld },
    url,
  } = useContext(StaticContext);
  const [appDetails, setAppDetails] = useState();
  const { noIndex, canonicalUrl } = getCanonicalUrlOrNoIndex(subdomain, domain, tld, url);

  const onQueryComplete = ({ publishedApplicationListingDetails: data }) => {
    // TODO: all the tracking stuff
    setAppDetails(data);
  };

  const { loading, error } = useQuery(publishedApplicationListingDetails, {
    variables: { language: 'en', appId },
    onCompleted: (data = {}) => onQueryComplete(data),
  });
  return (
    <BasePage pageId="App Directory - Details" includeHeader={false} legacyWeb="papi">
      <ModernHeader v2="true" />
      <Choose>
        <When condition={error}>
          <ErrorCard data-testid="DetailsV2__AppDirectoryError" />
        </When>
        <When condition={loading}>
          <AppDirectoryAppDetailsSkeleton data-testid="DetailsV2__AppDirectorySkeleton" />
        </When>
        <When condition={!appDetails}>
          <div data-testid="DetailsV2__AppDirectoryNotFound">
            <FourOhFourError />
          </div>
        </When>
        <Otherwise>
          <Helmet>
            <title>{`${appDetails.name} - SurveyMonkey App Integration`}</title>
            <meta name="description" content={appDetails.tagline} />
            <If condition={!noIndex}>
              <link rel="canonical" href={canonicalUrl} />
            </If>
            <If condition={noIndex}>
              <meta name="robots" content="noindex, nofollow" />
            </If>
          </Helmet>
          <AppDetails appDetails={appDetails} />
        </Otherwise>
      </Choose>
    </BasePage>
  );
};

DetailsPage.propTypes = {
  match: PropTypes.shape({
    params: PropTypes.shape({
      appId: PropTypes.string.isRequired,
    }).isRequired,
  }).isRequired,
};

export default DetailsPage;
